"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var react_1 = require("@emotion/react");

exports.wrapper = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: 13px;\n  letter-spacing: -0.4px;\n  line-height: 1;\n  font-weight: 500;\n  color: var(--blue-400);\n\n  & > img {\n    margin-right: 4px;\n  }\n"])));